const rewardProgramHistoryExample = [
  {
    eventType: "quarterlyLevel",
    event: "26T1",
    date: "2026-04-05T09:00:00-03:00",
    description:
      "Primeira classificação trimestral do programa com base no faturamento do trimestre anterior.",
    firstMonthRevenue: 56000,
    secondMonthRevenue: 72000,
    thirdMonthRevenue: 84000,
    averageRevenue: 70666.67,
    newLevel: "silver"
  },
  {
    eventType: "monthlyBonus",
    event: "26M4",
    date: "2026-05-05T08:00:00-03:00",
    points: 980,
    description: "Acúmulo mensal referente ao fechamento de abril de 2026.",
    currentLevel: "silver",
    monthlyRevenue: 98000,
    currentMultiplier: 0.01,
    pointsBefore: 0,
    pointsAfter: 980
  },
  {
    eventType: "bonus",
    event: "bonus",
    date: "2026-05-15T14:30:00-03:00",
    points: 500,
    description: "Bônus pontual de campanha por performance regional.",
    pointsBefore: 980,
    pointsAfter: 1480
  },
  {
    eventType: "monthlyBonus",
    event: "26M5",
    date: "2026-06-05T08:00:00-03:00",
    points: 1130,
    description: "Acúmulo mensal referente ao fechamento de maio de 2026.",
    currentLevel: "silver",
    monthlyRevenue: 113000,
    currentMultiplier: 0.01,
    pointsBefore: 1480,
    pointsAfter: 2610
  },
  {
    eventType: "redemption",
    event: "redemption",
    date: "2026-06-20T16:10:00-03:00",
    points: 1200,
    description: "Resgate de benefício no catálogo do programa.",
    pointsBefore: 2610,
    pointsAfter: 1410
  },
  {
    eventType: "quarterlyLevel",
    event: "26T2",
    date: "2026-07-05T08:30:00-03:00",
    description:
      "Reclassificação trimestral após crescimento do faturamento médio do trimestre.",
    currentLevel: "silver",
    firstMonthRevenue: 88000,
    secondMonthRevenue: 102000,
    thirdMonthRevenue: 95000,
    averageRevenue: 95000,
    newLevel: "gold"
  },
  {
    eventType: "levelAchievmentBonus",
    event: "achievmentOfLevelGold",
    date: "2026-07-05T08:35:00-03:00",
    points: 3000,
    description: "Bônus por atingir o nível Gold pela primeira vez.",
    currentLevel: "gold",
    currentMultiplier: 0.016,
    pointsBefore: 1410,
    pointsAfter: 4410
  },
  {
    eventType: "monthlyBonus",
    event: "26M6",
    date: "2026-07-07T08:00:00-03:00",
    points: 1520,
    description: "Acúmulo mensal referente ao fechamento de junho de 2026.",
    currentLevel: "gold",
    monthlyRevenue: 95000,
    currentMultiplier: 0.016,
    pointsBefore: 4410,
    pointsAfter: 5930
  },
  {
    eventType: "quarterlyLevel",
    event: "26T3",
    date: "2026-10-05T08:30:00-03:00",
    description: "Reclassificação trimestral.",
    currentLevel: "gold",
    firstMonthRevenue: 88000,
    secondMonthRevenue: 102000,
    thirdMonthRevenue: 95000,
    averageRevenue: 95000,
    newLevel: "gold"
  },
  {
    eventType: "quarterlyLevel",
    event: "26T4",
    date: "2027-01-01T08:30:00-03:00",
    description: "Reclassificação trimestral.",
    currentLevel: "gold",
    firstMonthRevenue: 40000,
    secondMonthRevenue: 40000,
    thirdMonthRevenue: 40000,
    averageRevenue: 40000,
    newLevel: "silver"
  }
];

export default rewardProgramHistoryExample;
